module.exports = __webpack_public_path__ + "img/birds.e3cb71f1.png";